module.exports = __webpack_public_path__ + "img/allemagne.d810f621.svg";